export default "__VITE_ASSET__N9Dc9NN8__"